import { useState } from "react";

export default function EmailTemplateForm({
  template,
  onClose,
  onSubmit
}) {

  const [form, setForm] = useState({
    useCase: template.useCase || "",
    category: template.category || "transactional",
    subjectTemplate: template.subjectTemplate || "",
    htmlTemplate: template.htmlTemplate || "",
    textTemplate: template.textTemplate || ""
  });

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-end">

      <div className="w-[500px] bg-white p-6 overflow-auto">

        <h2 className="text-xl font-bold mb-4">
          {template.id ? "Edit" : "Create"} Email Template
        </h2>

        <input
          name="useCase"
          placeholder="Use Case"
          value={form.useCase}
          onChange={handleChange}
          className="w-full border p-2 mb-3"
        />

        <select
          name="category"
          value={form.category}
          onChange={handleChange}
          className="w-full border p-2 mb-3"
        >
          <option value="transactional">Transactional</option>
          <option value="marketing">Marketing</option>
        </select>

        <input
          name="subjectTemplate"
          placeholder="Subject"
          value={form.subjectTemplate}
          onChange={handleChange}
          className="w-full border p-2 mb-3"
        />

        <textarea
          name="htmlTemplate" 
          placeholder="HTML Template"
          value={form.htmlTemplate}
          onChange={handleChange}
          rows={5}
          className="w-full border p-2 mb-3"
        />

        <textarea
          name="textTemplate"
          placeholder="Text Template"
          value={form.textTemplate}
          onChange={handleChange}
          rows={3}
          className="w-full border p-2 mb-3"
        /> <textarea
          name="actionJson" 
          placeholder="" 
          value={form.actionJson}
          onChange={handleChange}
          rows={3}
          className="w-full border p-2 mb-3"
        /> <textarea
          name="tenantId" hidden
          placeholder="Text Template"
          value={35}
          onChange={handleChange}
          rows={3}
          className="w-full border p-2 mb-3"
        />

        <div className="flex justify-end gap-3">
          <button onClick={onClose}>Cancel</button>
          <button
            onClick={() => {onSubmit(form);console.log(form)}}
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            Save
          </button>
        </div>

      </div>

    </div>
  );
}